export default async function getSessionTokenInfos() {
  try {
    const [incognia, shield, fingerprint] = await Promise.all([
      window.Device?.generateIncogniaSessionToken?.(),
      window.Device?.generateShieldSessionIdAndDeviceId?.(),
      window.Device?.fetchDeviceId?.(),
    ])

    const tokens = {
      incognia_session_token: incognia,
      shield_session_info: shield,
      fingerprint_token: fingerprint,
    }

    return Object.fromEntries(Object.entries(tokens).filter(([, value]) => value != null))
  } catch (e) {
    console.log('Erro ao obter o token de sessão das fornecedoras', e)
    return null
  }
}
